export const getArtistsStarted = () => ({
    type:'GET_ARTISTS_STARTED',
});

export const getArtistsSuccess = (artists) => ({
    type:'GET_ARTISTS_SUCCESS',
    payload:artists
});

export const getArtists = (url) => {
    return (dispatch)  => {
        dispatch(getArtistsStarted());
        fetch(url)
        .then(res=>res.json())
        .then(async res=>{
            let arr = res.artists.artist;
            let artists = arr.map( artist => {
               return fetch(`https://api.genius.com/search?q=${artist.name}&limit=1&access_token=W9YRsCxZ1uJvh97K48L-EfCt50u6H_74Ywuz2oNUg8hwOhTeW8jrvcTOxwNzU0UJ`,
                    {
                        method: 'GET',                 
                    }
                )
                .then(res => res.json()).then(res)
            });
            let artistInfo = await Promise.all(artists);
            let artistDetails = [];
            artistInfo.forEach( (artist,index) =>{
                let obj = {};
                let response = artist.response.hits;
                let len = response.length;
                for(let i=0;i<len;i++){
                    if(response[i].result.primary_artist.name.toLowerCase()===arr[index].name.toLowerCase()){
                        obj["id"] = response[i].result.primary_artist.id;
                        obj["artist"] = arr[index].name;
                        obj["image"] = response[i].result.primary_artist.image_url;
                        artistDetails.push(obj);
                        break;
                    }
                }
            });
            dispatch(getArtistsSuccess(artistDetails));
        });
    }
}


// export const getArtists = (url) => {
//     return (dispatch)  => {
//         dispatch(getArtistsStarted());
//         fetch(url)
//         .then(res=>res.json())
//         .then(res=>{
//             let arr = res.tracks.track;
//             let promises = arr.map(track=>{
//                 return fetch(`https://api.genius.com/search?q=${track.name}&access_token=W9YRsCxZ1uJvh97K48L-EfCt50u6H_74Ywuz2oNUg8hwOhTeW8jrvcTOxwNzU0UJ`,
//                     {
//                         header: {
//                             'Access-Control-Allow-Origin':'*',
//                           }
//                     }
//                 )
//                     .then(res=>res.json()).then(res);
//             });
//             Promise.all(promises)
//             .then( res => {
//                 const len = res.length;
//                 let tracks =[]
//                 for(let i=0;i<len;i++){
//                     let obj = {};
//                     let result = res[i].response.hits[0].result;
//                     obj["id"] = result.id;
//                     if(i===88)
//                         obj["image"] = result.song_art_image_thumbnail_url;
//                     else
//                         obj["image"] = result.header_image_thumbnail_url;
//                     // eslint-disable-next-line                        
//                     obj["title"] = result.title.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, '');
//                     obj["artist"] = result.primary_artist.name;
//                     tracks.push(obj);
//                 }
//                 dispatch(getTracksSuccess(tracks))
//             });
//         });
//     }
// }